const UserPermissions = {
  mainPage: false,
  projectsPage: true,
  batchesPage: true,
  usersPage: false,
  viewImages: true,
  annotate: true,
  addProject: false,
  addBatch: false,
  addUser: false,
  addPermissions: false,
  addImages: false,
  viewBatches: true,
  deleteProjects: false,
  deleteBatches: false,
  export: false,
  import: false,
  editUsers: false,
  showWhizz: false

}
export default UserPermissions
